import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	Tooltip,
	MenuItem,
	Menu,
} from '@material-ui/core';
import TableContainer from "@material-ui/core/TableContainer";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Chip from '@material-ui/core/Chip';
import { useActions, useValues } from 'kea';

import VehicleNoImage from '../../resources/tracker-icons/sedan-white-active.png';
import profilelogic from 'src/store/profile';
import checkRole from 'src/utils/checkRole';
import vehiclelogic from 'src/store/vehicle';
import ActionButton from './ActionButtons';
import ImageUpload from '../../components/ImageUpload';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const Results = ({ className, rows, columns, remove_vehicle_handler, edit_vehicle_handler, ...rest }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [showAllAnchor, setShowAllAnchor] = React.useState(null);
	const [showAllData, setShowAllData] = React.useState(null);

	const { profile } = useValues(profilelogic);

	const { updateImage } = useActions(vehiclelogic);


	const handleChangePage = (_even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};
	let valid_rows = rows && rows !== undefined && rows !== [] && rows !== null;

	const showAllGroups = (e, groups) => {
		setShowAllAnchor(e.currentTarget);
		setShowAllData(groups.map(g => g.name));
	}

	const showAllKeys = (e, keys) => {
		setShowAllAnchor(e.currentTarget);
		setShowAllData(keys.map(d => `${d.name} - ${d.id}`));
	}

	const closeShowAllGroups = () => {
		setShowAllAnchor(null);
	}

	const handleImageFinish = (e) => {
		updateImage(e)
	}


	return (
		<Card
			className={clsx(classes.root, className)}
			{...rest}
		>

			<Menu
				id="long-menu"
				anchorEl={showAllAnchor}
				keepMounted
				open={Boolean(showAllAnchor)}
				onClose={closeShowAllGroups}
				PaperProps={{
					style: {
						maxHeight: 48 * 4.5,
						width: '40ch',
					},
				}}
			>
				{showAllData ? showAllData.map((option) => (
					<MenuItem key={option}>
						{option}
					</MenuItem>
				)) : null}
			</Menu>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableHead>
							<TableRow>
								{columns.map((column) => {
									if (column.field === 'groups' && !checkRole(profile, ['Admin'])) {
										return null;
									}
									if (column.field === 'geofences' && !checkRole(profile, ['GeofenceEdit', 'GeofenceView'])) {
										return null;
									}
									if (column.field === 'alerts' && !checkRole(profile, ['AlertEdit', 'AlertView'])) {
										return null;
									}
									if (column.field === 'keys' && !checkRole(profile, ['KeyEdit', 'KeyView'])) {
										return null;
									}
									return <TableCell
										key={column.field}
										// align={column.align}
										style={{ minWidth: column.width }}
									>
										{column.headerName}
									</TableCell>
								})}
							</TableRow>
						</TableHead>
						<TableBody>
							{
								valid_rows ?
									rows
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => {
											if (row.removed) return null;
											return (
												<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
													{columns.map((column) => {
														if (column.field === 'groups' && !checkRole(profile, ['Admin'])) {
															return null;
														}
														if (column.field === 'geofences' && !checkRole(profile, ['GeofenceEdit', 'GeofenceView'])) {
															return null;
														}
														if (column.field === 'alerts' && !checkRole(profile, ['AlertEdit', 'AlertView'])) {
															return null;
														}
														if (column.field === 'keys' && !checkRole(profile, ['KeyView', 'KeyEdit'])) {
															return null;
														}
														if (column.field === 'image') {
															return (
																<TableCell key={column.field} align={column.align}>
																	<ImageUpload defaultImage={VehicleNoImage} image={row?.image?.image} onFinish={handleImageFinish} id={row._id} />

																</TableCell>
															)
														}
														if (column.field === 'reginfo') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{withTooltip(`${row.type} - ${row.registration_number} - ${row.registration_state}`, column.width)}
																</TableCell>
															)
														}
														if (column.field === 'info') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{withTooltip(`${row.color} ${row.year} ${row.company} ${row.model}`, column.width)}
																</TableCell>
															)
														}
														if (column.field === 'actions') {
															return (
																<TableCell key={column.field} align={column.align}>
																	<ActionButton row={row} />
																</TableCell>
															)
														}


														if (column.field === 'alerts') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{
																		row.alerts?.length > 1 ?
																			<Tooltip title={'Show All'}>
																				<Chip variant='outlined' color='primary' label={'Show All'} style={{
																					margin: '4px'
																				}} onClick={(e) => showAllGroups(e, row.alerts)} />
																			</Tooltip > : row.alerts?.map((alert, index) => {
																				if (index > 1) {
																					return null;
																				}
																				return (
																					<Chip style={{
																						margin: '4px'
																					}} label={alert.name} />
																				)
																			})}
																</TableCell>
															)
														}
														if (column.field === 'keys') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{
																		row.keys?.length > 1 ?
																			<Tooltip title={'Show All'}>
																				<Chip variant='outlined' color='primary' label={'Show All'} style={{
																					margin: '4px'
																				}} onClick={(e) => showAllKeys(e, row.keys)} />
																			</Tooltip > : row.keys?.map((key, index) => {
																				if (index > 1) {
																					return null;
																				}
																				return (
																					<Chip style={{
																						margin: '4px'
																					}} label={`${key.name} - ${key.id}`} />
																				)
																			})}
																</TableCell>
															)
														}
														if (column.field === 'geofences') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{
																		row.geofences?.length > 1 ?
																			<Tooltip title={'Show All'}>
																				<Chip variant='outlined' color='primary' label={'Show All'} style={{
																					margin: '4px'
																				}} onClick={(e) => showAllGroups(e, row.geofences)} />
																			</Tooltip > : row.geofences?.map((geofence, index) => {
																				if (index > 1) {
																					return null;
																				}
																				return (
																					<Chip style={{
																						margin: '4px'
																					}} label={geofence.name} />
																				)
																			})}
																</TableCell>
															)
														}
														if (column.field === 'groups') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{
																		row.groups?.length > 1 ?
																			<Tooltip title={'Show All'}>
																				<Chip variant='outlined' color='primary' label={'Show All'} style={{
																					margin: '4px'
																				}} onClick={(e) => showAllGroups(e, row.groups)} />
																			</Tooltip > : row.groups?.map((group, index) => {
																				if (index > 1) {
																					return null;
																				}
																				return (
																					<Chip style={{
																						margin: '4px'
																					}} label={group.name} />
																				)
																			})}
																</TableCell>
															)
														}
														const value = row[column.field];
														return (
															<TableCell key={column.field} align={column.align}>
																{column.format && typeof value === "number"
																	? column.format(value)
																	: withTooltip(value, column.width)}
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <Typography>No Vehicles Found</Typography>
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={rows ? rows.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
				{/* </Paper> */}
			</div>
		</Card >
	);
};

Results.propTypes = {
	className: PropTypes.string,
	rows: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
};

export default Results;
